export default "__VITE_ASSET__C0SrOv3u__"